import React from 'react';
import { useAuth } from '../context/AuthContext';
import '../css/Header.css';

const Header = () => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    window.location.reload();
  };

  return (
    <header className="header">
      <div className="logo">
        <h1>OG Web Guru</h1>
      </div>
      <button className="logout-btn" onClick={handleLogout}>
        Logout
      </button>
    </header>
  );
};

export default Header;
